/* Vida do buybox Dawn copiado (o global.js do Dawn dele nao roda aqui):
   galeria com miniaturas, sliders (galeria mobile, miniaturas, "Combina bien con"),
   seletor de variantes -> input id do form NATIVO (buy_buttons), preco e foto;
   slot [data-cl-app-slot] recebe o app block do Kaching + variant_picker nativo (PDP padrao). */
(function () {
  'use strict';
  function fmt(c, f) {
    f = f || '{{amount}}';
    var n = (c / 100).toFixed(2), p = n.split('.');
    var a = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','), b = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, b + ',' + p[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, b)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, a)
      .replace(/\{\{\s*amount\s*\}\}/, a + '.' + p[1]);
  }

  // ---- sliders Dawn (cl-slider-component / cl-slideshow-component) ----
  function slider(host) {
    if (host.__clS) return; host.__clS = true;
    var list = host.querySelector('.clx-slider, [id^="Slider-"]'); if (!list) return;
    var prev = host.querySelector('.clx-slider-button--prev'), next = host.querySelector('.clx-slider-button--next');
    var cur = host.querySelector('.slider-counter--current'), tot = host.querySelector('.slider-counter--total');
    function items() { return Array.prototype.filter.call(list.children, function (x) { return x.offsetParent !== null || x.getBoundingClientRect().width > 0; }); }
    function step() { var it = items(); return it.length > 1 ? (it[1].offsetLeft - it[0].offsetLeft) || it[0].clientWidth : list.clientWidth; }
    function idx() { var s = step() || 1; return Math.round(list.scrollLeft / s); }
    function upd() {
      var n = items().length, per = Math.max(1, Math.round(list.clientWidth / (step() || 1))), pages = Math.max(1, n - per + 1), i = Math.min(idx(), pages - 1);
      if (cur) cur.textContent = i + 1; if (tot) tot.textContent = pages;
      if (prev) prev.toggleAttribute('disabled', i <= 0);
      if (next) next.toggleAttribute('disabled', i >= pages - 1);
    }
    function go(d) {
      var s = step(); list.scrollTo({ left: list.scrollLeft + d * s, behavior: 'smooth' });
      // trilho sem rolagem (overflow visivel): gira a classe ativa
      setTimeout(upd, 400);
    }
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(-1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(1); });
    list.addEventListener('scroll', function () { clearTimeout(list.__t); list.__t = setTimeout(upd, 60); }, { passive: true });
    // arraste de mouse (o toque ja rola nativo)
    var x0 = null, s0 = 0, moved = false;
    list.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; x0 = e.clientX; s0 = list.scrollLeft; moved = false; });
    window.addEventListener('pointermove', function (e) { if (x0 === null) return; var dx = e.clientX - x0; if (Math.abs(dx) > 5) { moved = true; list.style.scrollSnapType = 'none'; list.scrollLeft = s0 - dx; } });
    window.addEventListener('pointerup', function () { if (x0 === null) return; x0 = null; list.style.scrollSnapType = ''; if (moved) { var s = step() || 1; list.scrollTo({ left: Math.round(list.scrollLeft / s) * s, behavior: 'smooth' }); setTimeout(function () { moved = false; }, 80); } });
    list.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    list.addEventListener('dragstart', function (e) { e.preventDefault(); });
    upd();
  }

  // ---- galeria: miniatura -> midia ativa ----
  function gallery(root) {
    var g = root.querySelector('[id^="Slider-Gallery-"]'), th = root.querySelector('[id^="Slider-Thumbnails-"]');
    if (!g || g.__clG) return; g.__clG = true;
    function show(i, scroll) {
      var lis = g.children; if (!lis[i]) return;
      Array.prototype.forEach.call(lis, function (li, k) { li.classList.toggle('clx-is-active', k === i); });
      if (th) Array.prototype.forEach.call(th.querySelectorAll('.clx-thumbnail'), function (b, k) {
        if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
      if (scroll !== false && g.scrollWidth > g.clientWidth + 2) g.scrollTo({ left: lis[i].offsetLeft - g.children[0].offsetLeft, behavior: 'smooth' });
    }
    if (th) th.addEventListener('click', function (e) {
      var b = e.target.closest('.clx-thumbnail'); if (!b) return; e.preventDefault();
      show(Array.prototype.indexOf.call(th.querySelectorAll('.clx-thumbnail'), b));
    });
    // botoes da galeria (mobile/desktop) avancam a midia ativa tambem
    var host = g.closest('cl-slider-component');
    if (host) ['prev', 'next'].forEach(function (k, d) {
      var b = host.querySelector('.clx-slider-button--' + k); if (!b) return;
      b.addEventListener('click', function () {
        var cur = Array.prototype.findIndex.call(g.children, function (li) { return li.classList.contains('clx-is-active'); });
        if (g.scrollWidth <= g.clientWidth + 2) show(Math.max(0, Math.min(g.children.length - 1, cur + (d ? 1 : -1))), false);
      });
    });
    root.__clShow = show;
  }

  // ---- variantes ----
  function applyVariant(root, P, v, own) {
    var pr = root.querySelector('[data-cl-price]');
    if (pr) {
      var on = v.compare_at_price > v.price, box = pr.querySelector('.clx-price');
      if (box) box.classList.toggle('clx-price--on-sale', on);
      pr.querySelectorAll('.clx-price__regular .clx-price-item--regular').forEach(function (x) { x.textContent = fmt(v.price, P.money); });
      pr.querySelectorAll('s.clx-price-item--regular').forEach(function (x) { x.textContent = fmt(v.compare_at_price || 0, P.money); });
      pr.querySelectorAll('.clx-price-item--sale').forEach(function (x) { x.textContent = fmt(v.price, P.money); });
    }
    root.querySelectorAll('[data-cl-atc]').forEach(function (b) { b.disabled = !v.available; });
    if (v.featured_media && root.__clShow && root.__clMedia !== v.featured_media.id) {
      root.__clMedia = v.featured_media.id;
      var lis = root.querySelector('[id^="Slider-Gallery-"]').children;
      for (var k = 0; k < lis.length; k++) if ((lis[k].id || '').slice(-String(v.featured_media.id).length) === String(v.featured_media.id)) { root.__clShow(k); break; }
    }
    if (own) try { history.replaceState(null, '', location.pathname + '?variant=' + v.id); } catch (_) {}
  }
  function variants(root) {
    var pj = root.querySelector('[data-cl-product]'); if (!pj || root.__clV) return; root.__clV = true;
    var P = JSON.parse(pj.textContent), formId = root.getAttribute('data-form-id');
    root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cl-opt]')) return;
      var want = [];
      root.querySelectorAll('[data-cl-opt]:checked').forEach(function (i) { want[+i.getAttribute('data-cl-opt') - 1] = i.value; });
      var v = P.variants.find(function (x) { return x.options.every(function (o, k) { return want[k] == null || o === want[k]; }); });
      if (!v) return;
      var f = document.getElementById(formId), inp = f && f.querySelector('input[name="id"]');
      if (inp) { inp.value = v.id; inp.dispatchEvent(new Event('change', { bubbles: true })); }
      applyVariant(root, P, v, true);
    });
    // seletor NATIVO (variant_picker no slot) ou o app Kaching mudaram o id do form nativo:
    // preco/foto/ATC do buybox copiado acompanham
    function fromForm() {
      var f = document.getElementById(formId), inp = f && f.querySelector('input[name="id"]');
      var v = inp && P.variants.find(function (x) { return String(x.id) === String(inp.value); });
      if (v) applyVariant(root, P, v, false);
    }
    document.addEventListener('change', function (e) {
      var t = e.target, slot = root.querySelector('[data-cl-app-slot]');
      if ((slot && slot.contains(t)) || (t.name === 'id' && t.form && t.form.id === formId)) {
        fromForm(); setTimeout(fromForm, 400); setTimeout(fromForm, 1500);
      }
    });
  }

  // ---- slot: blocos nativos (variant_picker de reserva + app block do Kaching) entram no lugar
  // do widget de kit do concorrente, dentro do buybox copiado ----
  function slot(root) {
    var s = root.querySelector('[data-cl-app-slot]'), host = root.closest('.cl-pdp-host');
    if (!s || !host || !host.parentElement) return;
    [].slice.call(host.parentElement.children).forEach(function (c) {
      if (c === host || c.matches('script,style,noscript,link')) return;
      if (c.matches('.shopify-app-block') || c.querySelector('kaching-bundle, [class*="kaching"]')) { c.classList.add('cl-nb-app'); s.appendChild(c); }
      else if (c.matches('variant-selects, variant-radios') || c.querySelector('variant-selects, variant-radios')) { c.classList.add('cl-nb-variants'); s.appendChild(c); }
    });
  }


  // ---- "Loved by 100,000+ women": trilho de videos do buybox (o tema dele abria um modal que
  // nao copiamos) -> Swiper com os mesmos parametros + toque no video toca/pausa com som ----
  function videoRail(el) {
    if (el.__clVR) return; el.__clVR = true;
    if (window.Swiper) {
      try {
        new window.Swiper(el, { speed: 300, slidesPerView: 'auto', spaceBetween: 16,
          navigation: { nextEl: el.querySelector('[class*="video-btn-next"]'), prevEl: el.querySelector('[class*="video-btn-prev"]') } });
      } catch (_) {}
    }
    el.addEventListener('click', function (e) {
      var slide = e.target.closest('.swiper-slide'); if (!slide) return;
      var v = slide.querySelector('video'); if (!v) return;
      e.preventDefault();
      el.querySelectorAll('video').forEach(function (o) { if (o !== v) { o.pause(); o.closest('.swiper-slide').classList.remove('cl-playing'); } });
      if (v.paused) { v.muted = false; v.controls = false; v.play().catch(function () { v.muted = true; v.play(); }); slide.classList.add('cl-playing'); }
      else { v.pause(); slide.classList.remove('cl-playing'); }
    });
  }

  function boot() {
    document.querySelectorAll('.cl-pdp').forEach(function (r) { slot(r); gallery(r); variants(r); });
    document.querySelectorAll('cl-slider-component, cl-slideshow-component').forEach(slider);
    document.querySelectorAll('.swiper[class*="video-slider-"]').forEach(videoRail);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', boot);
  window.clPdpBoot = boot;
})();
